export default __webpack_public_path__ + "static/media/RIDESAMPLE.8488577c.png";